import {Select} from "@mantine/core";


export interface SearchSelectOption {
  value: string,
  label: string
}

interface SearchSelectProps {
  data: SearchSelectOption[],
  value: string | null,
  onChange: (value: string | null) => void,
  label?: string,
  placeholder?: string,
  searchPlaceholder?: string,
  nothingFoundMessage?: string,
  disabled?: boolean
}

export default function SearchSelect({
                                       data,
                                       value,
                                       onChange,
                                       label = "",
                                       placeholder = "",
                                       nothingFoundMessage = "Nothing found",
                                       disabled = false
                                     }: SearchSelectProps) {
  return (
    <Select
      label={label || undefined}
      placeholder={placeholder}
      data={data}
      value={value}
      onChange={(val) => onChange(val)}
      disabled={disabled}
      searchable
      nothingFoundMessage={nothingFoundMessage}
      clearable={false}
      comboboxProps={{withinPortal: true}}
    />
  );
}
